import { IConfig, IConfigAction } from '../../../models/config';

export const SET_CONFIG = 'digest/SET_CONFIG';
export const SET_SUBDOMAIN = 'digest/SET_SUBDOMAIN';

const initialState: IConfig = {
  frontContentUrl: '',
  backContentUrl: '',
  subdomain: 'www',
  abGroup: 100,
};

const defaultAction: IConfigAction = {
  type: '',
  payload: {
    abGroup: 100,
    frontContentUrl: '',
    backContentUrl: '',
    subdomain: 'www',
  },
};

export const configReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case SET_CONFIG:
      return Object.assign({}, state, {
        frontContentUrl: action.payload.frontContentUrl,
        backContentUrl: action.payload.backContentUrl,
      });

    case SET_SUBDOMAIN:
      return Object.assign({}, state, {
        subdomain: action.payload.subdomain,
      });

    default:
      return state;
  }
};

export const setConfig = (contentUrl: string) => {
  return {
    type: SET_CONFIG,
    payload: {
      frontContentUrl: contentUrl,
      backContentUrl: contentUrl,
    },
  };
};

export const setSubdomain = (subdomain: string) => {
  return {
    type: SET_SUBDOMAIN,
    payload: { subdomain },
  };
};
